import _get from 'lodash/get'
import type { ReactElement } from 'react'
import React from 'react'

import { COLOR } from '@ui-kit/constants'

import { SHAPES } from './shapes'
import { icon } from './styles'
import type { WebProps } from './types'

export const BackgroundShapeContainer = (
  props: Pick<WebProps, 'bgColor' | 'bgShape'> & { className?: string }
) => {
  const { bgShapeContainer } = icon()
  if (!props.bgShape || !props.bgColor) {
    return null
  }
  return (
    <svg className={bgShapeContainer({ className: props.className })} viewBox="0 0 64 64">
      <path d={SHAPES[props.bgShape]} fill={COLOR[props.bgColor]} />
    </svg>
  )
}

const resolveImgSrc = (imgSrc: unknown): string => {
  if (typeof imgSrc === 'string') {
    return imgSrc
  }

  return _get(imgSrc, 'default.src', '')
}

const SvgIcon = (props: WebProps): ReactElement => {
  const { container, image } = icon()
  const imgPath = resolveImgSrc(props.imgSrc)
  return (
    <div className={container({ className: props.className })}>
      <BackgroundShapeContainer
        bgShape={props.bgShape}
        bgColor={props.bgColor}
        className={props.className}
      />
      <img src={imgPath} alt="" className={image()} />
    </div>
  )
}

export default SvgIcon
